export const BenefitSummaryTabsSkeletonWeb = () => {
  return (
    <div className="hidden xl:flex justify-center gap-4 lg:gap-24 text-xs lg:text-sm font-bold">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="tab cursor-pointer py-4 flex flex-col items-center">
          <div className="flex items-center gap-2 z-10">
            {/* Icon placeholder */}
            <div className="h-6 w-6 rounded-full bg-gray-300 animate-pulse" />

            {/* Text placeholder */}
            <div className="h-4 w-20 rounded bg-gray-300 animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
};

export const BenefitSummaryMobileTabsSkeleton = () => {
  return (
    <div className="flex xl:hidden justify-center w-full text-xs font-bold overflow-x-auto scrollbar-hide items-center gap-2">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="w-full cursor-pointer py-4 flex items-center justify-center">
          <div className="z-10 flex flex-col gap-2 items-center w-full justify-center text-center">
            {/* Icon placeholder */}
            <div className="h-6 w-6 rounded-full bg-gray-300 animate-pulse" />

            {/* Text placeholder */}
            <div className="h-4 w-16 rounded bg-gray-300 animate-pulse mb-2" />
          </div>
        </div>
      ))}
    </div>
  );
};
